"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var getClassNames = Utilities_1.classNamesFunction();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardDetailsBase = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentCardDetailsBase, _super);
    function DocumentCardDetailsBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardDetailsBase.prototype.render = function () {
        var _a = this.props, children = _a.children, styles = _a.styles, theme = _a.theme, className = _a.className;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return React.createElement("div", { className: this._classNames.root }, children);
    };
    return DocumentCardDetailsBase;
}(Utilities_1.BaseComponent));
exports.DocumentCardDetailsBase = DocumentCardDetailsBase;
//# sourceMappingURL=DocumentCardDetails.base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DocumentCard/DocumentCardDetails.base.js
// module id = 956
// module chunks = 0